import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Despesa',
    parent: 'traveiculo',
    path: '/transporte/tradespesa/:traVeiculoId',
    name: 'tradespesa',
    component: () => import('@/views/transporte/tradespesa/CadastroComGrid.vue'),
    meta: { permissions: [eTipoPermissao.VEICULOSNOVO_MENU_1100200299] },
    goesToMenu: false,
  },
];
